import { AuthCoverConfig } from './AuthCoverLayout';
import { APP_NAME } from '../../constants/brand';

export type AuthFeature = {
  title: string;
  description: string;
  color: string;
  icon: 'fleet' | 'trip' | 'driver' | 'bilty' | 'fuel' | 'maintenance' | 'reports';
};

export type AuthPillar = {
  title: string;
  description: string;
  icon: 'secure' | 'fast' | 'simple';
};

export const AUTH_PILLARS: AuthPillar[] = [
  { title: 'Secure', description: 'Your data is safe and protected', icon: 'secure' },
  { title: 'Fast', description: 'Access everything in seconds', icon: 'fast' },
  { title: 'Simple', description: 'Built for a smoother experience', icon: 'simple' },
];

export const LOGIN_COVER: AuthCoverConfig = {
  headline: 'Welcome back to',
  headlineAccent: APP_NAME,
  intro: 'Sign in to access your account and continue your journey with Tripiigo.',
  pillars: AUTH_PILLARS,
};

export const REGISTER_COVER: AuthCoverConfig = {
  headline: 'Get started with',
  headlineAccent: APP_NAME,
  intro: 'Register your transport company and manage fleet, trips, bilty and billing in one place.',
  pillars: AUTH_PILLARS,
};

export const FORGOT_COVER: AuthCoverConfig = {
  headline: 'Recover access to',
  headlineAccent: APP_NAME,
  intro: 'Enter your email and we will send a secure link to reset your password.',
  pillars: AUTH_PILLARS,
};

export const RESET_COVER: AuthCoverConfig = {
  headline: 'Create a new password for',
  headlineAccent: APP_NAME,
  intro: 'Choose a strong password to keep your fleet and billing data safe.',
  pillars: AUTH_PILLARS,
};
